import PageHero from "../components/sections/PageHero";
import SectionLabel from "../components/ui/SectionLabel";
import ScrollReveal from "../components/motion/ScrollReveal";
import StaggerContainer from "../components/motion/StaggerContainer";
import TiltCard from "../components/motion/TiltCard";

const notItems = [
  "NOT a cheap freelancer marketplace",
  "NOT a cookie-cutter template shop",
  "NOT a company that ghosts you after launch",
  "NOT a single-service agency that outsources the rest",
];

const verticals = [
  {
    title: "Web & Digital",
    items: ["Websites", "SEO", "Marketing", "E-commerce", "Branding"],
  },
  {
    title: "Software & Enterprise",
    items: ["Custom Software", "CRM", "ERP", "SaaS", "APIs"],
  },
  {
    title: "AI & Automation",
    items: ["AI Models", "Agents", "Call Centers", "Workflows"],
  },
];

const geography = [
  { phase: "Current", regions: "United States · United Kingdom · UAE · Europe · India" },
  { phase: "Next", regions: "Expanded multi-city service landing pages across each region" },
  { phase: "Long-term", regions: "500+ SEO-safe location-service pages with CMS-managed growth" },
];

const About = () => (
  <>
    <PageHero
      label="ABOUT"
      title="We are not"
      titleAccent="a typical agency."
      subtitle="Intelligent systems. Real results. We don't just execute — we think strategically. We are the quiet, confident expert in the room."
    />

    <section style={{ background: "#050505", padding: "0 0 100px" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 clamp(20px, 4vw, 48px)" }}>

        {/* Brand Core */}
        <ScrollReveal direction="up" delay={0}>
          <div
            style={{
              background: "#1A1208",
              border: "1px solid rgba(212,168,67,0.24)",
              borderRadius: 4,
              padding: "32px clamp(24px, 4vw, 36px)",
              marginBottom: 40,
            }}
          >
            <SectionLabel text="BRAND CORE" />
            <div style={{ marginTop: 20, display: "grid", gap: 14 }}>
              {[
                ["Company", "Obsidian Web Labs"],
                ["Short Name", "OWL"],
                ["Founded", "Delhi, India"],
                ["Location", "Headquartered in New Delhi, India · Serving clients globally"],
              ].map(([label, value]) => (
                <div key={label}>
                  <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 11, letterSpacing: "0.18em", color: "#D4A843", textTransform: "uppercase", marginBottom: 3 }}>
                    {label}
                  </div>
                  <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 15, color: "#F8F4EC" }}>{value}</div>
                </div>
              ))}
            </div>
          </div>
        </ScrollReveal>

        {/* What OWL is NOT */}
        <ScrollReveal direction="up" delay={0.1}>
          <div
            style={{
              background: "#0E0E0E",
              border: "1px solid rgba(212,168,67,0.18)",
              borderRadius: 4,
              padding: "30px clamp(24px, 4vw, 36px)",
              marginBottom: 40,
            }}
          >
            <SectionLabel text="WHAT OWL IS NOT" />
            <StaggerContainer stagger={0.08} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 16, marginTop: 20 }}>
              {notItems.map((item) => (
                <div key={item} style={{ padding: "16px 18px", border: "1px solid rgba(212,168,67,0.14)", borderRadius: 4, background: "#111010", fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC", lineHeight: 1.7 }}>
                  {item}
                </div>
              ))}
            </StaggerContainer>
          </div>
        </ScrollReveal>

        {/* Vision & Mission */}
        <StaggerContainer
          stagger={0.12}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: 20,
            marginBottom: 40,
          }}
        >
          <TiltCard style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: 28 }}>
            <SectionLabel text="VISION" />
            <p style={{ marginTop: 16, fontFamily: "'DM Sans', sans-serif", fontSize: 15, color: "#F8F4EC", lineHeight: 1.8 }}>
              To become India&apos;s most trusted full-stack digital intelligence partner.
            </p>
          </TiltCard>
          <TiltCard style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: 28 }}>
            <SectionLabel text="MISSION" />
            <p style={{ marginTop: 16, fontFamily: "'DM Sans', sans-serif", fontSize: 15, color: "#F8F4EC", lineHeight: 1.8 }}>
              To empower businesses of every size with intelligent digital systems that drive measurable growth, operational efficiency, and competitive advantage.
            </p>
          </TiltCard>
        </StaggerContainer>

        {/* Three Verticals */}
        <ScrollReveal direction="up" delay={0}>
          <div style={{ marginBottom: 40 }}>
            <SectionLabel text="THREE VERTICALS" />
            <StaggerContainer stagger={0.1} style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 16, marginTop: 20 }}>
              {verticals.map((vertical) => (
                <TiltCard key={vertical.title} style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: 28 }}>
                  <h3 style={{ fontFamily: "'Playfair Display', serif", fontWeight: 300, fontSize: 26, color: "#F8F4EC", marginBottom: 14 }}>
                    {vertical.title}
                  </h3>
                  <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    {vertical.items.map((item) => (
                      <div key={item} style={{ display: "flex", gap: 10, fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#908A83" }}>
                        <span style={{ color: "#D4A843" }}>—</span>
                        <span>{item}</span>
                      </div>
                    ))}
                  </div>
                </TiltCard>
              ))}
            </StaggerContainer>
          </div>
        </ScrollReveal>

        {/* Geography */}
        <ScrollReveal direction="up" delay={0.1}>
          <div>
            <SectionLabel text="GEOGRAPHY" />
            <div style={{ marginTop: 20, background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: "20px clamp(20px, 4vw, 30px)" }}>
              {geography.map((item) => (
                <div key={item.phase} style={{ padding: "16px 0", borderBottom: "0.5px solid rgba(212,168,67,0.12)" }}>
                  <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 11, letterSpacing: "0.2em", color: "#D4A843", textTransform: "uppercase", marginBottom: 6 }}>
                    {item.phase}
                  </div>
                  <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 15, color: "#F8F4EC" }}>{item.regions}</div>
                </div>
              ))}
            </div>
          </div>
        </ScrollReveal>

      </div>
    </section>
  </>
);

export default About;
